// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select[data-v-d56cf05c] {\n  max-width: 75px;\n  padding-top: 0px !important;\n  margin-top: 0px !important;\n}\n.item-price[data-v-d56cf05c] {\n  align-items: flex-end;\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
